import React, { forwardRef } from 'react';
export const Price = forwardRef(function Price({ as: Component = 'span', testId = 'store-price', value, formatter = (price) => price, variant = 'selling', ...otherProps }, ref) {
    const formattedPrice = formatter(value, variant);
    return (React.createElement(Component, Object.assign({ ref: ref, "data-store-price": true, "data-testid": testId, "data-variant": variant }, otherProps), formattedPrice));
});
export default Price;
//# sourceMappingURL=Price.js.map